module.exports = __webpack_public_path__ + "img/content-title.aa7a6792.png";